<template>
  <nav>
    <div class="align-items-center"
         :class="longClass">
      <template v-for="(item, index) in list">
        <button type="button"
                class="btn m-1"
                :class="buttonClassString(index)"
                :disabled="isDisabled(index)"
                v-on:click="movePhase(index)">
          {{item}}
        </button>
        <hr class="flex-grow-1"
            v-if="index != list.length - 1" />
      </template>
    </div>
    <div :class="shortClass"
         id="shortProgressNav">
      <div class="collapse show"
           id="progressCollapseToggleButton"
           data-bs-parent="#shortProgressNav"
           aria-expanded="true">
        <button class="d-block w-100 btn btn-outline-primary"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#progressButtonList"
                aria-controls="progressButtonList">
          {{activePhaseValue}}
        </button>
      </div>
      <div class="collapse collapse__target"
           id="progressButtonList"
           area-expanded="false"
           data-bs-parent="#shortProgressNav">
        <div class="d-flex flex-column">
          <button v-for="(item, index) in list"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#progressCollapseToggleButton"
                  class="btn rounded-0"
                  :class="buttonClassString(index, true)"
                  :disabled="isDisabled(index)"
                  v-on:click="movePhase(index)">
            {{item}}
          </button>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
  import { defineComponent } from "vue";

  export default defineComponent({
    props: {
      list: {
        type: Array,
      },
      borderPhase: {
        type: Number,
        default: null,
      },
      activePhase: {
        type: Number,
        default: 0,
        validator: (val) => {
          return 0 <= val;
        },
      },
      enableActivePhaseProgress: {
        type: Boolean,
        default: false,
      },
      isLocked: {
        type: Boolean,
        default: false,
      },
      breakpoint: {
        type: String,
        default: null,
        validator: (val) => {
          return [null, "sm", "md", "lg", "xl", "xxl"].includes(val);
        },
      },
    },
    computed: {
      shortClass: function () {
        if (this.breakpoint === null) {
          return "d-none";
        }
        return `d-block d-${this.breakpoint}-none`;
      },
      longClass: function () {
        if (this.breakpoint === null) {
          return "d-flex";
        }
        return `d-none d-${this.breakpoint}-flex`;
      },
      activePhaseValue: function () {
        return this.list[this.status.phase];
      },
    },
    data: () => {
      return {
        status: {
          phase: 0,
        },
        activePhaseProgress: 0,
      }
    },
    methods: {
      movePhase(phase) {
        if (this.isLocked) {
          return;
        }
        this.status.phase = phase;
        if (this.activePhaseProgress < this.status.phase) {
          this.activePhaseProgress = this.status.phase;
        }
        this.$emit("move", this.status);
      },
      moveNextPhase() {
        if (this.list.length -1 <= this.status.phase) {
          return;
        }
        this.movePhase(this.status.phase + 1);
      },
      movePrevPhase() {
        if (this.status.phase <= 0) {
          return;
        }
        this.movePhase(this.status.phase - 1);
      },
      buttonClassString(phase, isList = false) {
        let isActive = this.status.phase === phase;
        let isEnable = (this.enableActivePhaseProgress && phase <= this.activePhaseProgress) || (phase <= this.status.phase);
        return {
          "btn-primary": isActive,
          "btn-outline-primary": !isActive && isEnable,
          "btn-outline-secondary": !isActive && !isEnable,
          "border-top-0": isList && phase != 0,
        };
      },
      isDisabled(phase) {
        if (Number.isFinite(this.borderPhase) && phase <= this.borderPhase) {
          return true;
        }
        if ((this.enableActivePhaseProgress && phase <= this.activePhaseProgress) ||
          (phase <= this.status.phase)) {
          return false;
        }
        return true;
      },
    },
    created() {
      this.status.phase = this.activePhase;
      this.activePhaseProgress = this.activePhase;
    },
  });

</script>
